import { AdminTodoResponse } from "../../../services";

export const reviewableActionCount = ({
  pendingCorporateActions,
  notYetEffectiveCorporateActions,
  deferredCorporateActions,
}: AdminTodoResponse): number =>
  pendingCorporateActions -
  notYetEffectiveCorporateActions -
  deferredCorporateActions;
